import NoImageSectionCard from "../general/noImageSectionCard";
import Accordion from "../general/ui-blocks/elements/accordion";
import GeneralHeroSection from "../educate/generalHeroSection";


export default function MissionBodyComponent(props) {

    return (
        <div>

            <div className="layout-container d-flex flex-column min-vh-100 overflow-x-hidden">
                <GeneralHeroSection title="Mission & Philosophy" blurb={"Building a core foundation for the years ahead."}
                                    imageURL="https://storage.googleapis.com/extern-academy.firebasestorage.app/images/5521750.webp"
                                    imageALT="Mission & Philosophy Banner Image"
                />

                <main role="main" className="flex-grow-1"><a id="main-content" tabIndex="-1"></a>
                    <div className="row g-0">
                        <div className="col-12 col-lg">
                            <div>
                                <div id="block-sas-content">
                                    <article>
                                        <NoImageSectionCard
                                            title="Our Mission & Philosophy"
                                            blurb={<div className="space-y-4 text-left">
                                                <p>
                                                    Extern Academy exists for the builders.
                                                </p>
                                                <p>
                                                    For too long, general education has treated students like passengers. Show up. Listen. Take notes. Repeat. You graduate with a GPA and a transcript that looks exactly like everyone else’s.
                                                </p>
                                                <p>
                                                    <strong>That’s broken.</strong>
                                                </p>
                                                <p>
                                                    Here, you join a small team and own a real role — Product, Engineering, Design, Marketing, Growth, or Operations. You have a Startup Trainer: a founder who has raised capital and shipped to real users. You have a deadline. And by the end, you’ve built and launched a consumer product that goes live.
                                                </p>
                                                <p>
                                                    That’s the difference between <i>knowing</i> how to build something and having actually built it.
                                                </p>
                                            </div>}
                                        />

                                        <Accordion title="Our Mission" blurb={<div>
                                            <p>
                                                To give ambitious high school students their first real proof that they can build something that matters. A live product pointing to you.
                                            </p>
                                        </div>} />
                                        <Accordion title="Our Strategy" blurb={<div>
                                            <p>
                                                Small teams. Real roles. A vetted founder as your Startup Trainer. Two structured standups per week, async work in between, and a hard deadline at the end. Students own their domain — Product, Engineering, Design, Marketing, Growth, or Operations — and take it all the way through launch.
                                            </p>
                                            <p className="mt-3">
                                                The output is a live consumer product, a letter of recommendation from an accomplished startup founder, and a story worth every word.
                                            </p>
                                        </div>} />
                                    </article>
                                </div>
                            </div>
                        </div>
                    </div>
                </main>
            </div>
        </div>
    )
}